module.exports = __webpack_public_path__ + "assets/lucky-wheel-win-8a0ccd.png";